'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /** @jsx dom */


var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _streamlineUtilities = require('@viskan/streamline-utilities');

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
	closeOthers: false,
	openNodes: []
};

var getSharedProps = function getSharedProps(props) {
	return {
		iconClosed: props.iconClosed,
		iconOpen: props.iconOpen,
		linkTitle: props.linkTitle,
		parentLinkPrefix: props.parentLinkPrefix,
		renderParentLink: props.renderParentLink,
		styleClasses: props.styleClasses,
		toggle: function toggle(payload) {
			return props.toggle(_extends({}, payload, {
				closeOthers: props.closeOthers,
				tree: props.tree
			}));
		}
	};
};
var getNodes = function getNodes() {
	var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var props = arguments[1];
	var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

	if (!nodes || nodes.length === 0) {
		return;
	}

	var sharedProps = getSharedProps(props);
	var nodesToMap = props.showHiddenCategories ? nodes : nodes.filter(function (node) {
		return !node.hidden;
	});

	return nodesToMap.map(function (node) {
		var key = node.categoryId + '-' + props.linkTitle + '-' + props.renderParentLink + '-' + props.parentLinkPrefix + '-' + props.showHiddenCategories + '-' + props.path;
		var nodeProps = {
			data: node,
			level: level,
			isOpen: props.openNodes.includes(node.categoryId),
			parentChildren: props.children.filter(function (x) {
				return parseInt(x.attributes.categoryLinkId, 10) === node.categoryId;
			})
		};
		return (0, _magicVirtualElement2.default)(
			_.Node,
			_extends({ key: key }, sharedProps, nodeProps),
			!props.levels || level < props.levels ? getNodes(node.children, props, level + 1) : []
		);
	});
};

var getNodesManual = function getNodesManual() {
	var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var props = arguments[1];
	var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

	var sharedProps = getSharedProps(props);

	return nodes.map(function (node) {
		var key = node.attributes.id + '-' + props.linkTitle + '-' + props.renderParentLink + '-' + props.parentLinkPrefix + '-' + node.attributes.name + '-' + props.showHiddenCategories + '-' + props.path;
		var nodeProps = {
			id: node.attributes.id,
			data: {
				categoryId: node.attributes.id,
				linkFriendlyName: node.attributes.url,
				categoryName: node.attributes.name
			},
			level: level,
			isOpen: props.openNodes.includes(node.attributes.id)
		};

		return (0, _magicVirtualElement2.default)(
			_.Node,
			_extends({ cmsNode: true, key: key }, sharedProps, nodeProps),
			!props.levels || level < props.levels ? getNodesManual(node.children, props, level + 1) : []
		);
	});
};

var afterUpdate = function afterUpdate(_ref, prevProps) {
	var props = _ref.props;
	var id = props.id,
	    path = props.path,
	    tree = props.tree,
	    url = props.url;


	if (path && path !== prevProps.path) {
		props.getOpenNodes((0, _streamlineUtilities.findTreeByKey)('linkFriendlyName', url, tree), path, id);
	}
};

var beforeMount = function beforeMount(_ref2) {
	var props = _ref2.props;
	return props.getOpenNodes((0, _streamlineUtilities.findTreeByKey)('linkFriendlyName', props.url, props.tree), props.path, props.id);
};

var render = function render(_ref3) {
	var props = _ref3.props;
	var children = props.children,
	    iconSize = props.iconSize,
	    id = props.id,
	    includeParent = props.includeParent,
	    styleClasses = props.styleClasses,
	    tree = props.tree,
	    url = props.url;

	var currentData = (0, _streamlineUtilities.findTreeByKey)('linkFriendlyName', url, tree);

	if (!currentData && children.length === 0) {
		return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('div', { 'class': ['CMS-SubMenu', props.class, 'CMS-SubMenu--' + id, styleClasses.Sub_Menu], 'data-style-attr': 'Sub_Menu' }), props);
	}

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-SubMenu', props.class, 'CMS-SubMenu--' + id, props.displayIconBeforeTitle && 'CMS-SubMenu--iconBefore', styleClasses.Sub_Menu], 'data-style-attr': 'Sub_Menu' },
		(0, _magicVirtualElement2.default)(
			'style',
			null,
			'\n\t\t\t\t\t.CMS-SubMenu--' + id + ' .CMS-SubMenuNode-content {\n\t\t\t\t\t\tline-height: ' + iconSize + ';\n\t\t\t\t\t}\n\n\t\t\t\t\t.CMS-SubMenu--' + id + ' .CMS-SubMenuNode-toggler {\n\t\t\t\t\t\tfont-size: ' + iconSize + ';\n\t\t\t\t\t}\n\t\t\t\t'
		),
		currentData && (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-SubMenu-nodes', styleClasses.Nodes], 'data-style-attr': 'Nodes' },
			getNodes(includeParent ? [currentData] : currentData.children, props)
		),
		children.length !== 0 && (0, _magicVirtualElement2.default)(
			'div',
			{ 'class': ['CMS-SubMenu-nodes', styleClasses.Nodes], 'data-style-attr': 'Nodes' },
			getNodesManual(children, props)
		)
	), props);
};

exports.default = { afterUpdate: afterUpdate, beforeMount: beforeMount, defaultProps: defaultProps, render: render };